import moment from 'moment';

export default {
  methods: {
    timeLogsDuration(timeLogs, periodStartTime, periodEndTime, mode = 'day', where = null, timeLogStartValue = null, timeLogEndValue = null) {
      let totalDiff = 0;
      if (timeLogs && timeLogs.length > 0) {
        timeLogs.forEach((timeLog) => {
          if (!where || (where && where(timeLog))) {
            totalDiff += Math.abs(this.timeLogDuration(timeLog, periodStartTime, periodEndTime, mode, timeLogStartValue, timeLogEndValue));
          }
        });
      }

      return totalDiff;
    },

    timeLogDuration(timeLog, periodStartTime, periodEndTime, mode = 'day', timeLogStartValue = null, timeLogEndValue = null) {
      let ms;
      if (timeLog.category && timeLog.category.type && timeLog.category.type.includes('Pto')) {
        ms = timeLog.logged_days * 8 * 60 * 60 * 1000;
      } else {
        const startedAt = moment(timeLogStartValue ? timeLogStartValue(timeLog) : timeLog.started_at);
        const stoppedAt = moment(timeLogEndValue ? timeLogEndValue(timeLog) : timeLog.stopped_at);
        ms = moment(stoppedAt).diff(moment(startedAt));
      }
      return ms;
    },

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/mixins/duration.js